import type { SafeMetadata } from "../types";

const SENSITIVE_KEYS = [
	"password",
	"token",
	"secret",
	"apikey",
	"api_key",
	"creditcard",
	"credit_card",
	"authorization",
	"auth",
	"bearer",
	"refresh_token",
	"access_token",
];

export function sanitizeMetadata(
	metadata: Record<string, unknown>,
): SafeMetadata {
	const sanitized: SafeMetadata = {};

	for (const [key, value] of Object.entries(metadata)) {
		const lowerKey = key.toLowerCase();

		if (SENSITIVE_KEYS.some((sensitive) => lowerKey.includes(sensitive))) {
			sanitized[key] = "[REDACTED]";
			continue;
		}

		if (
			typeof value === "string" ||
			typeof value === "number" ||
			typeof value === "boolean" ||
			value === null
		) {
			sanitized[key] = value;
		} else if (Array.isArray(value)) {
			sanitized[key] = "[ARRAY]";
		} else if (typeof value === "object") {
			sanitized[key] = "[OBJECT]";
		} else {
			sanitized[key] = "[UNKNOWN]";
		}
	}

	return sanitized;
}
